export const dashboard = {
  contact: {
    title: 'Upload Contacts',
    button: 'Upload',
    description: 'To get started in Zorra, import the database of your clients or add numbers.'
  },

  mailing: {
    title: 'Create a Mailing',
    button: 'Create',
    description: 'Create a message for sms or use predefined templates.'
  },

  number: {
    title: 'Order a Number',
    button: 'Order',
    description: 'Additional information may be required during purchase process.'
  },

  pbx: {
    title: 'Set Up Virtual PBX',
    button: 'Set Up',
    description: 'Zorra service can provide a cloud solution for a VoIP telephony server.'
  },

  api: {
    title: 'API and Integration',
    button: 'Integrate',
    description:
      "Zorra service allows powerfull integration systems. In order to use Zorra API you should add your server's IP Address here"
  },

  prices: {
    title: 'All Services and Prices',
    button: 'Learn',
    description: 'Do you want to implement email marketing, but do not know what you need for this?'
  },

  first_entry: {
    title: 'Thank you for registration!',
    text: `Account credentials were sent to your email. <br /> <b>{value} welcome {currency}</b> have been credited to your account.`,
    start: 'Start using'
  },

  'data-base': {
    title: 'Call the client base',
    title2: 'Predictive dialer',
    description:
      'Predictive dialer allows you to quickly call a large volume of numbers and at the same time provide almost 100% load of operators.',
    button: 'Forward',
    button2: 'Connect'
  },

  noty: {
    'connect-autocaller': 'Predictive will be connected within a few minutes.'
  },

  'low-balance': 'The funds on your balance are coming to an end, we recommend replenishing it.',
  'unavailable_zorra': 'Maintenance Alert: Service will be unavailable on December 6, 2023 from 07:00 to 11:00 UTC',

  captcha:
    'This site is protected by reCAPTCHA and the Google <br />' +
    'Privacy Policy and Terms of Service apply.'
};
